import instance from "./interceptor";

import { handleEncrypt, handleDecrypt } from "../../service/common";
import { system_api } from "../../service/system";

function delayResponse(callback) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(callback()), system_api.delay);
  });
}

function formatSuccessResponse({ result, settings }) {
  let data = result.data;
  if (!data) return { Response: -1, message: "無回應" };

  if (data.res && settings.responseSecret) {
    data = handleDecrypt({
      CRYPTO_KEY: process.env.REACT_APP_CRYPTO_KEY,
      text: data.res,
    });
    data = JSON.parse(data);
  }

  data.Response = data.message?.includes("成功") ? 1 : 3;

  if (!data.Response) {
    return { Response: -1, data: result, message: "no Response" };
  }

  return {
    ...data,
    headers: result.headers,
  };
}

function formatErrorResponse(error) {
  let { code, response } = error;
  let Response = response?.status ? response.status : -1;
  const statusMsg = {
    401: "超過使用時限，請重新登入",
    403: "無權限使用",
    404: "無此 API",
    500: "資訊異常，請聯繫維修人員",
  };
  const codeMsg = {
    ECONNABORTED: "無法連線，請檢查網路是否正常",
    ERR_NETWORK: "無法連線，請檢查網路是否正常",
  };

  if (code === "ERR_CANCELED") return undefined;

  let message = "資訊異常，請聯繫維修人員";
  if ([401, 403, 404, 500].includes(response?.status)) {
    message = statusMsg[response.status];
  } else if (["ECONNABORTED", "ERR_NETWORK"].includes(code)) {
    message = codeMsg[code];
  }

  if (Response === 401) {
    setTimeout(() => {
      localStorage.clear();
    }, 1500);
  }

  return { Response, message };
}

function request({
  method,
  url,
  data: params,
  options,
  settings = { requestSecret: false, responseSecret: false },
} = {}) {
  let data = {};
  if (method === "get") data = { params };
  if (method === "post") {
    data = {
      data: settings.requestSecret
        ? {
            pos: handleEncrypt({
              CRYPTO_KEY: process.env.REACT_APP_CRYPTO_KEY,
              text: JSON.stringify(params),
            }),
          }
        : params,
    };
  }

  return instance({
    url,
    method,
    ...options,
    ...data,
  })
    .then((result) =>
      delayResponse(() => formatSuccessResponse({ result, settings })),
    )
    .catch((error) => delayResponse(() => formatErrorResponse(error)));
}

function get({ ...restParams } = {}) {
  return request({ method: "get", ...restParams });
}

function post({ ...restParams } = {}) {
  return request({ method: "post", ...restParams });
}

const requestApi = {
  get,
  post,
};

export default requestApi;
